<main appUniversalResources>
  <pixie-homepage></pixie-homepage>
</main>
<font-icon-loader></font-icon-loader>
